export default __webpack_public_path__ + "static/media/SpiffyPortraitEdit.4c78d5d0.png";